import type { TransfersSearchPayload } from './queries';
import { isPointValid, pointFromParams, toPayload } from './transferPointState';
import { transferOccupantsFromPassengers, transferPassengersFromParams } from './searchPassengers';
import { transferLuggageFromParams, transferLuggageSelection } from './transferLuggage';

/** A committed URL must describe a complete search before enabling the query. */
export function transferSearchPayloadFromParams(params: Record<string, string>): TransfersSearchPayload | null {
  if (params.buscar !== '1' || !params.fecha) return null;
  const origin = pointFromParams(params, 'o', 'iata');
  const destination = pointFromParams(params, 'd', 'coords');
  if (!isPointValid(origin) || !isPointValid(destination)) return null;
  const isRoundTrip = params.viaje === 'ROUNDTRIP';
  if (isRoundTrip && !params.fechaVuelta) return null;
  const passengers = transferPassengersFromParams(params);
  const occupants = passengers ? transferOccupantsFromPassengers(passengers) : null;
  const luggage = transferLuggageSelection(transferLuggageFromParams(params));
  if (!occupants || luggage === null) return null;
  return {
    tripType: isRoundTrip ? 'ROUNDTRIP' : 'ONEWAYTRIP',
    origin: toPayload(origin),
    destination: toPayload(destination),
    date: params.fecha,
    originTime: params.hora ?? '10:00',
    ...(isRoundTrip ? { endDate: params.fechaVuelta, destinationTime: params.horaVuelta ?? '15:00' } : {}),
    occupants,
    ...(luggage ? { luggage } : {}),
  };
}
